import { ProductSyncStatusResponse } from 'app/modules/settings/infrastructure/dto/response/ProductSyncStatusResponse';
import { ProductSyncStatus } from 'app/modules/settings/domain/entity/ProductSyncStatus';
import { SyncId } from 'app/modules/settings/domain/valueObject/SyncId';
import { SyncStatus } from 'app/modules/settings/domain/valueObject/SyncStatus';

export class ProductSyncStatusMapper {

    public static toDomain(response: ProductSyncStatusResponse): ProductSyncStatus {
        return new ProductSyncStatus(
            new SyncId(response.name),
            new SyncStatus(response.status),
            response.started_at ? new Date(response.started_at) : null,
            response.finished_at ? new Date(response.finished_at) : null,
            response.pending_count,
        );
    }

    public static toDomainArray(responses: ProductSyncStatusResponse[]): ProductSyncStatus[] {
        return responses.map((response) => ProductSyncStatusMapper.toDomain(response));
    }

}
